import type { CoreInputProps } from '../internal/WixUiCoreComponents/components/CoreInput';
import type { ErrorProps } from '../ErrorMessageWrapper';
import { TPAComponentProps } from '../../types';

interface InputBaseProps extends TPAComponentProps {
  /** the error message to display */
  errorMessage?: string;
  /** apply error state*/
  error?: boolean;
}
export type InputProps = ErrorProps & InputBaseProps & CoreInputProps;
